 
import { createSlice } from '@reduxjs/toolkit';
import { RunProcessType } from '@dynamika-shared/types/executions';
import { DICOMViewerProcessesState } from './DICOMViewerProcesses.types';
import { createSliceHook, makeActionCreator } from '../helpers';

const { actEmpty } = makeActionCreator<DICOMViewerProcessesState>();

const initialState: DICOMViewerProcessesState = {
  loading: false,
};

export const DICOMViewerProcessesSlice = createSlice({
  name: 'DICOMViewerProcesses',
  initialState,

  reducers: {
    runProcess: actEmpty<RunProcessType & { __callId?: string }>(),
  },
});

export const useDICOMViewerProcessesSlice = createSliceHook(
  DICOMViewerProcessesSlice.name,
  DICOMViewerProcessesSlice.actions
);
